import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  staffPermission,
  permissionChanges,
  permissionButton,
  allStaffPermissions,
} from 'src/app/post-login/services/staff.model';

@Component({
  selector: 'app-permission-buttons',
  templateUrl: './permission-buttons.component.html',
  styleUrls: ['./permission-buttons.component.scss'],
})
export class PermissionButtonsComponent implements OnInit {
  @Output() callOnChange: EventEmitter<any> = new EventEmitter<object>();
  @Input() permissions: staffPermission;
  @Input() permissionType: string;
  @Input() id1: string | any;
  @Input() id2: string | any;
  @Input() view: boolean;

  permission: staffPermission;
  id: string;
  permissionFor: string;
  viewPermission: boolean;
  editHideViewPermissions: permissionButton[];
  onOffPermissions: permissionButton[];
  position: { position1: number; position2: number };
  constructor() {}

  ngOnInit() {
    this.permission = this.permissions;
    this.permissionFor = this.permissionType;
    this.id = this.id1 + '' + this.id2;
    this.viewPermission = this.view;
    this.setPermissions();
  }
  setPermissions() {
    this.editHideViewPermissions = [
      {
        id: 'fullPermission-' + this.id,
        permission: this.permission.menuPermissions['F'] == 'true',
        type: this.permission.type === 'F',
        value: 'F',
        text: 'Edit',
        class: 'full',
      },
      {
        id: 'viewPermission-' + this.id,
        permission: this.permission.menuPermissions['V'] == 'true',
        type: this.permission.type === 'V',
        value: 'V',
        text: 'View',
        class: 'view',
      },
      {
        id: 'hidePermission-' + this.id,
        permission: this.permission.menuPermissions['H'] == 'true',
        type: this.permission.type === 'H',
        value: 'H',
        text: 'Hide',
        class: 'hidden',
      },
    ];
    this.onOffPermissions = [
      {
        id: 'on-' + this.id,
        type: this.permission.type === 'true',
        value: 'true',
        text: 'On',
        class: 'full',
      },
      {
        id: 'off-' + this.id,
        type: this.permission.type === 'false',
        value: 'false',
        text: 'Off',
        class: 'off',
      },
    ];
  }
  onChange(item: permissionButton) {
    if(this.permission.ownAccount) return;
    this.position = { position1: Number(this.id1), position2: Number(this.id2) };
    this.permission.type = item.value;
    this.callOnChange.emit({ permission: this.permission, position: this.position });
  }
}
